module.exports = __webpack_public_path__ + "img/undraw_profile.1da2f226.svg";